var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReport)?_c('div',[_c('Pivot',{key:'pivot_'+_vm.forceUpdate,attrs:{"report":_vm.dataReport,"toolbar":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }